import React from 'react'
import { connect } from 'react-redux'
import * as reportActions from 'lib/api/rideReports'
import {browserHistory, Link} from 'react-router'
import _ from 'lodash'
import moment from 'moment'
import smartDate from '@qrohlf/smart-date'
import {Navbar, NavbarGroup, NavbarTitle} from 'common/Navbar'
import appStyles from '../App/appStyles.scss'
import cx from 'classnames'
import styles from './NewPage.scss'
import {Button} from 'common/Button'
import {RidePickerContainer} from '../RidePicker'
import {getConsole} from 'lib/getConsole'
import {Gleam} from 'common/Gleam'
const console = getConsole('rr', 'NewPage')

export class NewPage extends React.Component {
  createReport = (selectedRides) => {
    const {newReport} = this.props
    // also generates a subtitle, but we ignore it because users can't
    // figure out how to change the defaults
    const {title} = getTitle(selectedRides)
    newReport({
      title,
      rides: selectedRides.toIndexedSeq().map(r => r.id).toJS()
    }).then(response => {
      browserHistory.push(`/ride_reports/${response.value.report.slug}/edit`)
    }).catch(err => {
      console.error(err, err.stack)
    })
  }

  render () {
    const {draftCount, currentUser} = this.props

    if (!currentUser.id) {
      window.location.href = `/login?redirect=${encodeURIComponent(window.location.href)}`
      return null
    }

    return (
      <div className={cx(appStyles.base, styles.wrapper)}>
        <Navbar>
          <NavbarGroup>
            <li><NavbarTitle to='/ride_reports'>Ride Reports</NavbarTitle></li>
            <li>new report</li>
          </NavbarGroup>
          <NavbarGroup>
            <li><Link to='/ride_reports/drafts'>your drafts {draftCount > 0 && <Gleam>{draftCount}</Gleam>}</Link></li>
            <li><Link to='/ride_reports/'><Button type='default'>&laquo; back</Button></Link></li>
          </NavbarGroup>
        </Navbar>
        <div className={styles.NewPage}>
          <h1 className={appStyles.pageTitle}>New Ride Report</h1>
          <p>Which rides do you want to write a ride report for?</p>
          <RidePickerContainer onConfirmSelection={this.createReport} />
        </div>
      </div>
    )
  }
}

const niceListString = (arr, oxfordComma = false) => {
  if (arr.length <= 2) {
    const comma = oxfordComma ? ',' : ''
    return arr.join(`${comma} and `)
  }
  return arr[0] + ', ' + niceListString(arr.slice(1), true)
}

export const getTitle = rides => {
  if (rides.size === 1) {
    const first = rides.valueSeq().first()
    const title = first.name
    const subtitle = smartDate(first.departed_at)
    return {title, subtitle}
  } else {
    const months = rides.valueSeq().map(r => moment(r.departed_at))
      .sort((a, b) => a > b)
      .map(d => d.format('MMMM')).toJS()
    const monthString = niceListString(_.sortedUniq(months))
    const title = `${rides.size} rides in ${monthString}`
    const subtitle = null
    return {title, subtitle}
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    draftCount: state.editPage.draftList.size
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    newReport: (report) => dispatch(reportActions.newReport(report))
  }
}

export const NewPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewPage)
